<style scoped>

.parent {
  min-height: 250px;
}

.child {
  min-height: 100px;
}

.child:nth-child(2) {
  position: relative;
  overflow: auto;
}

.inner {
  position: absolute;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 944px) {

  .inner {
    position: -webkit-sticky;
    position: sticky;
  }

  .child:nth-child(2) {
    height: 25vh;
  }

  .no-margin-in-size-small {
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>

<template>

<div class="full-height full-width display-flex display-flex-column" v-if="flagFetchedMedia">
  <mu-button small icon @click="onClickBack"><mu-icon value="keyboard_backspace" /></mu-button>
  <div class="parent display-flex">
    <div style="flex: 7" class="child flex-item">
      <video-item
        :media="media"
        :overlays="overlays"
        :timestamp="parseInt(timestamp)"
        v-if="flagFetchedMedia && (media.type==='video' || media.type==='youtube' || media.type==='mp4link')"
        @onUpdateTime="onUpdateTime"
        @onUpdateDuration="onUpdateDuration"
        :flagEditMode="true"
        @onUpdateOverlay="onUpdateOverlay"
        @onSelectedOverlay="onSelectedOverlay"
        />
    </div>
    <div style="flex: 3" class="child flex-item">
      <mu-container class="inner">
        <mu-appbar class="full-width" color="primary">
          <mu-menu slot="left">
            <mu-button flat v-tooltip="$t('button.add')">
              <mu-icon value="add" />
            </mu-button>
            <mu-list slot="content">
              <mu-list-item button @click="onClickAddText">
              <mu-list-item-action>
                <mu-icon value="note"></mu-icon>
              </mu-list-item-action>
              <mu-list-item-content>
                <mu-list-item-title>{{$t('overlay.text.display')}}</mu-list-item-title>
              </mu-list-item-content>
              </mu-list-item>
              <mu-list-item button @click="onClickAddImg">
              <mu-list-item-action>
                <mu-icon value="image"></mu-icon>
              </mu-list-item-action>
              <mu-list-item-content>
                <mu-list-item-title>{{$t('overlay.image.display')}}</mu-list-item-title>
              </mu-list-item-content>
              </mu-list-item>
            </mu-list>
          </mu-menu>
          <mu-button flat slot="left" v-tooltip="$t('overlay.saveAll')" @click="onClickSaveAll">
            <mu-icon value="save" />
          </mu-button>
        </mu-appbar>
        <overlay-editor
          :initData="overlaySelected"
          :initIndex="indexSelected"
          :duration="duration"
          :mediaId="mediaId"
          @onUpdateOverlay="onUpdateOverlay"
        />
      </mu-container>
    </div>
  </div>
  <div class="display-flex">
    <div style="flex: 1;"/>
    <mu-slider v-model="zoomRate" :min="20" :max="220" :displayValue="false"></mu-slider>
  </div>
  <div class="parent display-flex flex-item">
    <div class="child display-none">
    </div>
    <div class="child flex-item">
      <div class="inner">
        <timeline-editor
          :mediaId="mediaId"
          :initData="layoutData"
          :duration="duration"
          :widthGridLayout="widthGridLayout"
          @onClickListItem="onClickListItem"
          @onUpdateLayout="onUpdateLayout"
          @onDeleteListItem="onDeleteListItem"
          />
      </div>
    </div>
  </div>
  <mu-dialog :title="$t('button.delete') + $t('space') + $t('overlay.title')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogDelete">
    {{stringDelete}}
    <mu-button slot="actions" flat color="primary" @click="flagDialogDelete = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
</div>

</template>

<script>

// Library
import draggable from 'vuedraggable'
import axios from "axios";

// Components
import VideoItem from '@/components/Media/Content/VideoItem.vue'
import OverlayEditor from '@/components/Overlay/OverlayEditor.vue'
import TimelineEditor from '@/components/Overlay/TimelineEditor.vue'

// Utils
import timeFormatter from '@/utils/timeFormatter.js'

export default {
  name: 'OverlayPage',
  components: {
    VideoItem,
    OverlayEditor,
    draggable,
    TimelineEditor,
  },
  props: {
    mediaId: {
      type: String,
      required: true
    }
  },
  data() {
    return {

      loading: null,

      // Object
      media: "", // Media object
      overlaySelected: {}, // Overlay
      overlays: [],
      indexSelected: -1,
      duration: 0,
      deleteItem: "",
      timestamp: 0,

      zoomRate: 120,

      // Flag
      flagFetchedMedia: false, // Boolean variable for status of media fetched
      flagDialogDelete: false, // Boolean variable for status of delete dialog

      // Video
      currentTime: 0, // Current time of video
    }
  },
  computed: {
    // String
    stringDelete() {
      if(this.deleteItem.type == "text")
        return this.$t('prompt.deleteMsg', { name: this.deleteItem.content });
      else
        return this.$t('prompt.deleteMsg', { name: this.stringItem(this.deleteItem) });
    },

    // Flag
    isVideoReady() {
      if(this.duration === 0)
        return false;
      else
        return true;
    },

    // Timeline Layout
    layoutData: {
      get() {
        var array = [];
        this.overlays.forEach((element) => {
          array.push({"x": element.start, "y": element.order + 1, "w": element.duration, "h": 1, "i": element._id, "content": this.stringItem(element), "type": element.type });
        });
        return array;
      },
      set(newValue) {
        newValue.forEach((element, index) => {
          this.overlays[index].start = element.x;
          this.overlays[index].duration = element.w;
          this.overlays[index].order = element.y - 1;
        });
      }
    },
    widthGridLayout() {
      return this.zoomRate*100;
    },
  },
  created() {

    this.checkPermit();
  },
  methods: {
    // Fetch
    checkPermit() {
      axios.get(this.$store.getters.urlApi + "permit/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        var result = response.data.data.admin;
        if(result) {
          this.fetchMedia();
        } else {

          this.$router.push({
            name: 'Home'
          });
        }
      });
    },
    fetchMedia() {
      axios.get(this.$store.getters.urlApi + "media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.media = response.data.data.media
        this.flagFetchedMedia = true;
        this.fetchOverlays();
      });
    },
    fetchOverlays() {
      axios.get(this.$store.getters.urlApi + "overlay/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.overlays = response.data.data.overlays;
        this.flagFetchedOverlays = true;

      });
    },

    // Event
    onClickOverlayItem(item, index) {
      this.onSelectedOverlay({
        index: index
      })
      this.flagUnSaved = false;
      this.overlaySelected = item;
      this.indexSelected = index;
      this.timestamp = item.start;
    },
    onClickListItem(index) {
      this.onClickOverlayItem(this.overlays[index], index);
    },
    onDeleteListItem(index) {
      this.onClickDelete(this.overlays[index]);
    },
    onUpdateTime(timeNew) {
      this.currentTime = timeNew;
    },
    onUpdateDuration(duration) {
      this.duration = duration;
    },
    onUpdateOverlay(data) {
      this.overlays[data.index] = data.overlay;
      if(data.index === this.indexSelected)
        this.overlaySelected = data.overlay;
    },
    onUpdateLayout(newLayout) {
      this.layoutData = newLayout;
    },
    onSelectedOverlay(data) {
      if(this.indexSelected != -1) {
        this.onActionSave(this.indexSelected);
      }
      this.indexSelected = data.index;
      this.overlaySelected = this.overlays[data.index];
    },
    onActionSave(index) {
      axios.put(this.$store.getters.urlApi + "overlay/" + this.overlays[index]._id, this.overlays[index], {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      );
    },
    onClickAddText() {
      if(!this.flagAdding) {
        this.flagAdding = true;
        axios.post(this.$store.getters.urlApi + "overlay/media/" + this.mediaId, {
          'type': "text",
          'content': "text",
          'start': 1,
          'duration': 5,
          'xPos': 0.5,
          'yPos': 0.5,
          'fontSize': 30,
          'padding': 0,
          'order': this.overlays.length,
          'color': {
            r: 0,
            g: 0,
            b: 0,
            a: 1
          },
          'backgroundColor': {
            r: 0,
            g: 0,
            b: 0,
            a: 0
          }
          }, {
          headers: {
            token: this.$store.state.auth.token,
            'content-type': 'application/json'
          },
          }
        ).then(() => {
          this.fetchOverlays();
          this.flagAdding = false;
          this.$toast.success(this.$t('toast.create'));
        });
      }
    },
    onClickAddImg() {
      if(!this.flagAdding) {
        this.flagAdding = true;
        axios.post(this.$store.getters.urlApi + "overlay/media/" + this.mediaId, {
          'type': "img",
          'src': "",
          'start': 1,
          'duration': 5,
          'xPos': 0.5,
          'yPos': 0.5,
          'size': "width",
          'order': this.overlays.length,
          'sizeX': 0.1,
          'sizeY': 0.1
          }, {
          headers: {
            token: this.$store.state.auth.token,
            'content-type': 'application/json'
          },
          }
        ).then(() => {
          this.fetchOverlays();
          this.flagAdding = false;
          this.$toast.success(this.$t('toast.create'));
        });
      }
    },
    onClickDelete(item) {
      this.deleteItem = item;
      this.flagDialogDelete = true;
    },
    onActionDelete() {
      this.flagDialogDelete = false;
      axios.delete(this.$store.getters.urlApi + "overlay/" + this.deleteItem._id, {
        headers: {
          token: this.$store.state.auth.token
        },
        params: {
          'ids': this.attachmentIds
        }
        }
      ).then(() => {
        this.overlaySelected = {};
        this.indexSelected = -1;
        this.fetchOverlays();
        this.$toast.success(this.$t('toast.delete'));
      });
    },
    onClickSaveAll() {
      for(var key in this.overlays) {
        this.onActionSave(key);
      }
    },
    onMoved(data) {
      var newIndex = data.moved.newIndex;
      var oldIndex = data.moved.oldIndex;
      this.onActionReorder(newIndex, oldIndex);
    },
    onActionReorder(newIndex, oldIndex) {
      let formData = new FormData();
      formData.append('_method', 'PUT');
      formData.append('newIndex', newIndex);
      formData.append('oldIndex', oldIndex);
      axios.post(this.$store.getters.urlApi + "overlay/media/" + this.mediaId, formData, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      );
    },
    onClickBack() {
      if(this.$route.params.fromChannel) {
        if(typeof this.$route.params.playlistId !== 'undefined') {
          this.$router.push({
            name: 'ChannelPlaylist',
            params: {
              channelId: this.media.channel_id,
              playlistId: this.$route.params.playlistId
            }
          });
        } else {
          this.$router.push({
            name: 'Channel',
            params: {
              channelId: this.media.channel_id
            }
          });
        }
      } else {
        if(typeof this.$route.params.playlistId !== 'undefined') {
          this.$router.push({
            name: 'PlaylistMedia',
            params: {
              mediaId: this.mediaId,
              playlistId: this.$route.params.playlistId
            }
          });
        } else {
          this.$router.push({
            name: 'Media',
            params: {
              mediaId: this.mediaId
            }
          });
        }
      }
    },

    // String
    stringItem(item) {
      if(item.type === 'text') {
        return item.content;
      } else {
        if(item.src) {
          var str = item.src.split("/").reverse();
          return str[0];
        } else {
          return this.$t('overlay.empty');
        }
      }
    },
    stringTimeFormatter(sec) {
      return timeFormatter(sec);
    },
  },
}
</script>
